import React, { useState, useEffect } from 'react';
import {
    getAdminInvoices
} from "../../store/action/invoice";
import {isAuthenticated} from "../../store/action/auth";
import InvoiceTable from "../../components/tables/InvoiceTable";
import moment from 'moment';

const AdminInvoice = (props) => {
    const { token } = isAuthenticated();
    const [invoices,setInvoices] = useState([])
    const [loading, setLoading ] = useState(false)
    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            const resInv = await getAdminInvoices(token)
            if (resInv.success) {
                let invoicesData = resInv.invoices.reduce((r,i) => {
                    r.push({
                        id:i.id,
                        name:i.bill_to_name,
                        invoiceNo:i.reference_id,
                        period:i.period,
                        dueDate:moment(i.due_at).format("DD MMM YYYY"),
                        total:i.total,
                        status:i.status,
                        imageUrl:i.payment_image_url,
                        paidOrderBill: i.paid_order_bill,
                        items: i.items
                    })
                    return r
                },[])
                setInvoices(invoicesData)
            } else {
                alert(`Gagal ambil data`)
            }
            setLoading(false)
        } catch (e) {
            console.log (e);
            alert(`${e.message}`)
        }
    };

    return (
        <div className="mb-4">
            <div className="bg-white rounded shadow">
                <div className="pt-4 px-4 pb-1">
                    <h5>Informasi Invoice </h5>
                </div>
                <InvoiceTable
                    admin
                    data={invoices}
                    loading={loading}
                />
            </div>
        </div>
    )
}

export default AdminInvoice;